import React from 'react';
import { useRouteError } from 'react-router-dom';
import { Button, Result } from 'antd';
import loginEvent, { BackToHome } from '@/events/login-event';

const NotFoundPage = () => {
  const error = useRouteError() as any;
  console.error(error);

  return (
    <Result
      status="404"
      title="页面未找到"
      subTitle="抱歉，您访问的页面不存在"
      extra={<Button type="primary" onClick={() => loginEvent.emit(BackToHome)}>返回首页</Button>}
    />
  );
};

export default NotFoundPage;
